/**
 * Payroll Frequency Column Configuration
 *
 * This file defines the options for the 'Payroll Frequency' column in the TIFPA Workflow spreadsheet.
 *
 * Usage in column type mapper: 'payroll_frequency'
 */

export interface PayrollFrequencyOption {
  value: string;
  label: string;
}

/**
 * Payroll Frequency Options
 * Defines how often payroll is processed
 */
export const PAYROLL_FREQUENCY_OPTIONS: PayrollFrequencyOption[] = [
  {
    value: 'Monthly',
    label: 'Monthly',
  },
  {
    value: 'SemiMonthly',
    label: 'Semi-Monthly',
  },
  {
    value: 'BiWeekly',
    label: 'Bi-Weekly',
  },
  {
    value: 'Weekly',
    label: 'Weekly',
  },
];

/**
 * Helper function to get a Payroll Frequency option by value
 */
export function getPayrollFrequencyOption(
  value: string
): PayrollFrequencyOption | undefined {
  return PAYROLL_FREQUENCY_OPTIONS.find(opt => opt.value === value);
}

/**
 * Helper function to format Payroll Frequency options for cell editor overlay
 */
export function getPayrollFrequencyCellEditorOptions() {
  return PAYROLL_FREQUENCY_OPTIONS.map(opt => ({
    value: opt.value,
    label: opt.label,
  }));
}
